module.exports = __webpack_public_path__ + "img/bell.a7ab3cae.svg";